import { render, staticRenderFns } from "./ServidoresOLTPlacaUplinkPorta.vue?vue&type=template&id=c57e5202&"
import script from "./ServidoresOLTPlacaUplinkPorta.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLTPlacaUplinkPorta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports